import { styled, TextField, TextFieldProps, Typography } from '@mui/material';
import { GridContainer } from '../Grid/Grid.components';

export const CompactGridContainer = styled(GridContainer)(({ theme }) => ({
  rowGap: theme.spacing(3)
}));

export const StyledInputAdornmentTypography = styled(Typography)(
  ({ theme }) => ({
    fontSize: theme.typography.body2.fontSize,
    color: theme.palette.primary.main,
    position: 'absolute',
    top: theme.spacing(0.5),
    right: theme.spacing(8.25)
  })
);

export const StyledCustomTimePickerField = styled(TextField)<TextFieldProps>(
  () => ({
    '& .MuiInputAdornment-root': {
      marginLeft: 0
    }
  })
);
